import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import acceptTranslations from '~src/domains/accept/translations/translations';
import { Locale } from '~src/domains/common/enums/localization';
import commonTranslations from '~src/domains/common/translations/translations';
import faqTranslations from '~src/domains/faq/translations/translations';
import invalidAddressTranslations from '~src/domains/invalidAddress/translations/translations';
import loanConsentTranslations from '~src/domains/loanConsent/translations/translations';
import payTranslations from '~src/domains/pay/translations/translations';
import reacceptTranslations from '~src/domains/reaccept/translations/translations';
import reapplyTranslations from '~src/domains/reapply/translations/translations';
import startTranslations from '~src/domains/start/translations/translations';
import tripExpiredTranslations from '~src/domains/tripExpired/translations/translations';
import verifyTranslations from '~src/domains/verify/translations/translations';
import adverseTranslations from '~src/domains/adverse/translations/translations';
import noiTranslations from '~src/domains/noi/translations/translations';
import outOfFilterTranslations from '~src/domains/outOfFilter/translations/translations';
import creditFreezeTranslations from '~src/domains/creditFreeze/translations/translations';
import fullSSNTranslations from '~src/domains/fullSSN/translations/translations';

i18n.use(initReactI18next).init({
  lng: Locale.enUS,
  fallbackLng: Locale.enUS,
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    [Locale.enUS]: {
      common: commonTranslations[Locale.enUS],
      start: startTranslations[Locale.enUS],
      verify: verifyTranslations[Locale.enUS],
      accept: acceptTranslations[Locale.enUS],
      loanConsent: loanConsentTranslations[Locale.enUS],
      pay: payTranslations[Locale.enUS],
      adverse: adverseTranslations[Locale.enUS],
      reaccept: reacceptTranslations[Locale.enUS],
      reapply: reapplyTranslations[Locale.enUS],
      'invalid-address': invalidAddressTranslations[Locale.enUS],
      tripExpired: tripExpiredTranslations[Locale.enUS],
      faq: faqTranslations[Locale.enUS],
      noi: noiTranslations[Locale.enUS],
      outOfFilter: outOfFilterTranslations[Locale.enUS],
      creditFreeze: creditFreezeTranslations[Locale.enUS],
      fullSSN: fullSSNTranslations[Locale.enUS],
    },
    [Locale.enCA]: {
      common: commonTranslations[Locale.enCA],
      start: startTranslations[Locale.enCA],
      verify: verifyTranslations[Locale.enCA],
      accept: acceptTranslations[Locale.enCA],
      loanConsent: loanConsentTranslations[Locale.enCA],
      pay: payTranslations[Locale.enCA],
      adverse: adverseTranslations[Locale.enCA],
      reaccept: reacceptTranslations[Locale.enCA],
      reapply: reapplyTranslations[Locale.enCA],
      'invalid-address': invalidAddressTranslations[Locale.enCA],
      tripExpired: tripExpiredTranslations[Locale.enCA],
      faq: faqTranslations[Locale.enCA],
      outOfFilter: outOfFilterTranslations[Locale.enCA],
    },
    [Locale.frCA]: {
      common: commonTranslations[Locale.frCA],
      start: startTranslations[Locale.frCA],
      verify: verifyTranslations[Locale.frCA],
      accept: acceptTranslations[Locale.frCA],
      loanConsent: loanConsentTranslations[Locale.frCA],
      pay: payTranslations[Locale.frCA],
      adverse: adverseTranslations[Locale.frCA],
      reaccept: reacceptTranslations[Locale.frCA],
      reapply: reapplyTranslations[Locale.frCA],
      'invalid-address': invalidAddressTranslations[Locale.frCA],
      tripExpired: tripExpiredTranslations[Locale.frCA],
      faq: faqTranslations[Locale.frCA],
      outOfFilter: outOfFilterTranslations[Locale.frCA],
    },
  },
  react: {
    bindI18n: 'loaded languageChanged',
    bindI18nStore: 'added',
    useSuspense: false,
    transKeepBasicHtmlNodesFor: [
      'span',
      'div',
      'b',
      'br',
      'strong',
      'i',
      'p',
      'li',
      'ul',
      'table',
      'tbody',
      'tr',
      'td',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
    ],
  },
});

export default i18n;
